// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const CheckmarkCircle2Line: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M12 2l.28.004C17.673 2.152 22 6.57 22 12l-.004.28C21.848 17.673 17.43 22 12 22 6.477 22 2 17.523 2 12S6.477 2 12 2zm0 2a8 8 0 100 16l.25-.004A8 8 0 0020 12l-.004-.25A8 8 0 0012 4zm2.773 4.294A1.006 1.006 0 0116.29 9.61l-4.57 6a1 1 0 01-.79.39l-.13-.008a1 1 0 01-.66-.372l-2.43-3.11-.071-.104A1.001 1.001 0 019.29 11.28l1.63 2.11 3.78-5h-.01z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export const CheckmarkCircle2LineOffset: IconOffset = {
    vertical: 8,
    horizontal: 8,
};

export default React.memo(CheckmarkCircle2Line);
